var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlxScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cee5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23525,
    stopColor: "#7ce5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#23e5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13889b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.18933,
    y: 33.59613,
    width: 7.78436,
    height: 32.80774
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "70.4541 44.81683 67.42169 41.78442 62.24792 41.78442 62.24792 47.04144 65.2392 50.03271 62.24792 53.02484 62.24792 58.21021 67.48706 58.21021 70.45056 55.24585 73.41309 58.20844 78.66211 58.20844 78.66211 53.0293 75.66998 50.03717 78.66211 47.04144 78.66302 41.78442 73.48657 41.78442 70.4541 44.81683"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.86023,63.52368c7.46869,0,13.52325-6.05457,13.52325-13.52325s-6.05457-13.52319-13.52325-13.52319-13.52325,6.05457-13.52325,13.52319,6.05457,13.52325,13.52325,13.52325ZM34.86383,45.9032c2.26288,0,4.09729,1.83441,4.09729,4.09723h.00177v.00183c-.00098,2.26282-1.83618,4.09644-4.09906,4.09546-2.26288,0-4.09729-1.83441-4.09729-4.09729s1.83441-4.09723,4.09729-4.09723Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlxScraper);
export default __webpack_public_path__ + "static/media/olx-scraper.a55ac4f2ce7e1a47b50860369a72588b.svg";
export { ForwardRef as ReactComponent };